export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderBroadCast@2x.png";